import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';

import { useTranslation } from 'react-i18next';

// icon
import MapIcon from '@material-ui/icons/Map';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

// style
import { styles } from './style';

import StormDataLists from './StormDataLists/StormDataLists';
import StormHistoryDataLists from './StormHistoryDataLists/StormHistoryJtwc';
import StormMeaning from './StormHistoryDataLists/StormMeaning';

const useStyles = makeStyles(styles);

function TabPanel(props) {
  const {
    children, value, index,
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}
const TabContainer = ({ children }) => (
  <Box component="div">
    {children}
  </Box>
);

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function StormHistoryDatalists() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function List() {
    return (
      <>
        {/* <StormDataLists /> */}

        {/* ภาพพายุหมุนในอดีต ยังไม่สมบูรณ์พัฒนาในเฟสถัดไป */}
        <Tabs value={value} onChange={handleChange} indicatorColor="primary" scrollButtons="auto" variant="scrollable" aria-label="simple tabs example">
          <Tab
            label={(
              <>
                <MapIcon />
                <Box pl={1}>
                  {t('แผนที่พายุและความแรงพายุขณะนี้')}
                </Box>
              </>
            )}
            className={value === 0 ? classes.active_tab : classes.tab}
          />
          <Tab
            id="storm-history"
            label={(
              <>
                <AccessTimeIcon />
                {' '}
                <Box pl={1}>{t('ภาพพายุหมุนในอดีต')}</Box>
              </>
            )}
            className={value === 1 ? classes.active_tab : classes.tab}
          />
          <Tab
            id="storm-meaning"
            label={(
              <>
                <HelpOutlineIcon />
                {' '}
                <Box pl={1}>{t('ความหมายและที่มาของชื่อพายุ')}</Box>
              </>
            )}
            className={value === 2 ? classes.active_tab : classes.tab}
          />
        </Tabs>
        <Divider />
        <TabContainer component="div">
          <TabPanel value={value} index={0}>
            <StormDataLists />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <StormHistoryDataLists />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <StormMeaning />
          </TabPanel>
        </TabContainer>
      </>
    );
  }

  return (
    <div className={classes.root}>
      <Box mt={3}>
        <List />
      </Box>
    </div>
  );
}
